import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import greatSoulImg from "../../assets/images/the-great-souls/png/temple_the_great_souls.png";
import greatDecorate from "../../assets/images/coursesPage/LordGaveBapu/png/bapuBgDecorate.png";
import orangeTick from "../../assets/images/svg/orenge_tick.svg";
import Button from "../common/button/Button";
import CommonHeading from "../common/heading/CommonHeading";
import { ModalList } from "../../utils/TheGreateSageHelper";
import Modal from "../common/modal/Modal";
import { greateSageList } from "../../utils/TheGreateSageHelper";
const TheGreatSage = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="position-relative great_souls pt-2">
        {/*<img
          className="position-absolute bottom_flower_mahamantra end-0 maharaj_top z_index_n2"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/} 
        <img
          src={greatSoulImg}
          className="w-25 position-absolute start-0"
          style={{ bottom: "-10%" }}
          alt="temple_the_great_souls"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute start-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        <img
          src={greatDecorate}
          className="bapuBgDecorate position-absolute end-0 d-none d-sm-block"
          alt="bapuBgDecorate"
        />
        {/*<img
          className="position-absolute top_flower_mahamantra souls_top_flower start-0 the_great_flower"
          src={topFlowerImg}
          alt="top_flower"
        />*/}

        <div className="container_modified container position-relative mt-0 pt-3 pt-sm-4">
          <div className="row justify-content-center mt-xl-2">
            <div className="col-lg-11 text-center mb-4 pb-lg-2">
              <CommonHeading
                heading="The Great Sage"
                className="text-orange common_heading_text common_heading_text_brown"
              />
              <h2 className="common_sub_heading text-center mb-1 mb-md-3 px-4 px-md-0">
                P.P. Punitachariji Maharaj
              </h2>
            </div>
          </div>
          <div className="row justify-content-between mb-3 pb-3">
            <div className="col-lg-7">
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-5">
                  Life span of a saint is not to be viewed just as a story. It exemplifies how to live a happy life. Poojyashri has spent about’ sixty years of his life span in assiduous sadhana and tapasya and that sadhana is still continuing.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                  He carried out sadhana¬upasana of Ma Gayatri, Ma Bhuvaneshwari, and Lord Shiva in the caves of Himalaya Mountains, on sacred banks of Ganges and Narmada rivers and subsequently he moved to Girnar Mountains and continued arduous sadhana in a divine cave in Jatashankar area of this mountain. He continued sadhana for 16-18 hours a day unceasingly for many years without any obstruction whatsoever.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-4">
                Sadguru Dattatreya was immensely pleased with this tapasya carried out with a resolute intention and He appeared before Poojyashri in the midnight of 15thNov. 1975 on a rock near the Ashram. It is an improbable incident in the present times, With the kind blessings of Sadguru Dattatreya, Poojyashri immediately achieved Sahajavastha, Shambhavi Avastha and Buddhatva.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-xl-3">
                Sadguru asked Bapu for a boon. Maharishi Shri replied that he had no material desire left in him after the Darshan of Sadguru. On insistence, Maharishi Shri requested Sadguru to bestow upon a technique which may enable even sad, pitiable, poor and silly along with rich and intelligent people to attain peace and happiness.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-sm-5">
                Such feelings of compassion and kindness of a saint towards sad and depressed people moved even Gods, Goddesses, Siddhas and Saints and they appeared all over in the atmosphere. They were singing ‘Hari Om Tatsat Jai Guru Datta’ in a melodious tune. Subsequently, they declared that whosoever will chant or sing this mantra alone or in a group and then sit quietly and silently with eyes closed will be elevated to the meditative stage immediately and spontaneously.
                </p>
              </div>
              <div className="d-flex gap-2 mb-md-3 mb-2">
                <img src={orangeTick} className="mb-auto mt-1" alt="tick" />
                <p className="common_para lh_25 mb-0 pe-sm-5">
                He will experience immense mental peace and happiness during this state. Sadguru Dattatreya said that this mantra will fulfill your desire to bring peace to the masses. Since then, Maharishi Shri and his followers are propogating this mantra. Presently, a number of centers are working not only in India but in foreign countries also where regular programs of chanting-cum meditation are taking place.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-5 ps-lg-0 mx-auto mt-4 mt-lg-0">
              {greateSageList.map((obj, index) => {
                return (
                  <div
                    className="position-relative z-3 text-center"
                    key={index}
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 pb-lg-5 mb-3 mb-lg-2">
                      <Button title={obj.title} className="great_sage_btn" />
                    </div>
                    <img
                      src={obj.image}
                      className="w-100 max_sm_w cursor_pointer"
                      alt="sage-bapu-img"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default TheGreatSage;
